<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
    :hide-overlay="true"
  >
    <button
      :disabled="disabled"
      type="button"
      :class="className"
      id=""
      slot="activator"
      @click="openModal()"
    >{{ $t('action.cancelAddendum') }}</button>
    <modal
      ref="modal"
      :modalId="`cancel-addendum-${+new Date()}`"
    >
      <div
        id="cancel-addendum-container"
        class="modal-container"
      >
        <p class="modal-pure-text">{{ $t('warn.addendum.cancel') }}</p>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeModal()"
        >{{ $t('no') }}</button>
        <button
          type="button"
          class="btn btn--orange"
          v-hkldreset
          @click="fallbackAddendum()"
        >{{ $t('yes') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/controls/Modal'
import { fallbackTender } from '@/api/tender-addendums/request'

export default {
  name: 'CancelAddendum',
  components: {
    Modal,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clickCheck: {
      type: Function,
      default: () => { return true },
    },
    className: {
      type: String,
      default: 'btn btn--darkblue',
    },
  },
  data () {
    return {
      prNumber: '',
      hint: '',
    }
  },
  methods: {
    async openModal () {
      const checkResult = await this.clickCheck()
      if (!checkResult) return
      this.$refs.modal.open()
    },
    closeModal () {
      this.$refs.modal.close()
    },
    async fallbackAddendum () {
      await fallbackTender(this.$router.currentRoute.params.id)
      this.closeModal()
      this.$router.push({
        name: 'healthCheck',
        params: {
          id: this.$router.currentRoute.params.id,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/stickyBtn";
@import '~styles/popup';
#cancel-addendum-container .confirm-header {
  margin-bottom: 0;
}
</style>
